import React from 'react';
import styles from './ToolTip.css';

const ToolTip = ({ text, className = '' }) => (
  <span className={`${styles.toolTip} ${className}`}>
    {text}
  </span>
);

export default ToolTip;



// WEBPACK FOOTER //
// ./src/components/ToolTip/index.js